import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="children"
export default class extends Controller {
  static targets = ['parent', 'container', 'list'];

  connect() {
    // this.parentTarget.addEventListener('click', (event) => {
    //   console.log('parent: ', event.target);
    // })
  }

  items() {
    var id = this.parentTarget.value;
    var url = this.parentTarget.dataset.url;
    var sleep = 0;

    if(id && url){
      url += '?format=json&parent_id=' + id;
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.getItems(id, url);
      }, sleep);
    }
  }

  getItems(id, url) {
    console.log('id: ', id);
    if (id.length == 0) {
      this.hideItems();
      return;
    }

    fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': this.csrfToken(),
      }
    }).then(response => {
      response.json().then((data) => {

        var options = '<option value="">Seleziona</option>'
        // var children = JSON.parse(data);
        if(data.items && data.items.length > 0) {
          data.items.forEach(function(opt) {
            var label = ''
            if(opt.code){ label += opt.code + ' - ' }
            label += opt.name
            options += '<option value="' + opt.id + '">' + label + '</option>'
          });
          // console.log('options:', options);
          this.showItems();
        } else {
          this.hideItems();
        }
        this.listTarget.innerHTML = options;
      });
    });
  }

  hideItems(){
    this.containerTarget.classList.add('hidden');
    this.listTarget.removeAttribute('required');
  }

  showItems(){
    this.listTarget.setAttribute('required', true);
    this.containerTarget.classList.remove('hidden');
  }

  csrfToken() {
    const metaTag = document.querySelector('meta[name="csrf-token"]')
    return metaTag ? metaTag.content : ''
  }

}
